'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

let TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
let DutyViewModel=require('../../../dist-es6/client/viewModels/dutyViewModel');
let TripViewModel=require('../../../dist-es6/client/viewModels/tripViewModel');

let BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

DrivePlanService=function(_BaseService){_inherits(DrivePlanService,_BaseService);_createClass(DrivePlanService,null,[{key:'$inject',get:function()
{
return['timeZoneService','socketService'];
}}]);

function DrivePlanService(timeZoneService,socketService){_classCallCheck(this,DrivePlanService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._timeZoneService=timeZoneService;
_this._socketService=socketService;return _this;
}DrivePlanService.prototype.

getAndInflateRouteScenario=function(){var ref=_asyncToGenerator(function*(personId,waypoints){
let routeScenarioRequest={
personId:personId,
clientTimeZone:this._timeZoneService.localTimeZone,
waypoints:waypoints.map(function(wp){return{
address:wp.address,
time:wp.time.toISOString(),
type:wp.type}})};



let routeScenarioResponse=yield this._socketService.sendAndWaitForResponse('GetRouteScenario',routeScenarioRequest);

if(routeScenarioResponse.status!=='OK'){
return routeScenarioResponse;
}

let inflatedResponse=this._inflateRouteScenarioResponseFromJson(routeScenarioResponse);

return inflatedResponse;
});function getAndInflateRouteScenario(personId,waypoints){return ref.apply(this,arguments)}return getAndInflateRouteScenario}();DrivePlanService.prototype.

_inflateRouteScenarioResponseFromJson=function _inflateRouteScenarioResponseFromJson(routeScenarioResponse){
let{statusTransitions:statusTransitions,direction:direction,stops:stops}=routeScenarioResponse.route;
let{sleep:sleep,fatigue:fatigue,duties:duties,trips:trips}=routeScenarioResponse.schedule;

return{
route:{
statusTransitions:statusTransitions.map(function(st){return{time:new Date(st.time),value:st.value}}),
direction:direction,
stops:stops},

schedule:{
sleep:sleep.map(function(s){return new TimeInterval(s)}),
fatigue:fatigue.map(function(f){return{time:new Date(f.time),value:f.value}}),
duties:duties.map(function(d){return new DutyViewModel(d)}),
trips:trips.map(function(t){return new TripViewModel(t)})},

queryInterval:new TimeInterval(routeScenarioResponse.queryInterval)};

};return DrivePlanService}(BaseService);


module.exports=DrivePlanService;
//# sourceMappingURL=drivePlanService.js.map
